<template>
	<div class="ReSelectDirection">
		<el-checkbox-group v-model="value.all" v-if="typeof CAT_DIRECTIONS != 'undefined'">
			<div class="col-5">
				<el-checkbox v-for="direction in CAT_DIRECTIONS.n" :label="direction.id" :key="direction.id">{{direction.name}}</el-checkbox>
			</div>
			<div class="col-5">
				<el-checkbox v-for="direction in CAT_DIRECTIONS.s" :label="direction.id" :key="direction.id">{{direction.name}}</el-checkbox>
			</div>
		</el-checkbox-group>
	</div>
</template>

<script>
	import { CheckboxGroup, Checkbox } from 'element-ui';
	export default {
		name: 'ReSelectDirection',
		components: {
			[Checkbox.name]: Checkbox, 
			[CheckboxGroup.name]: CheckboxGroup,
		},
		props: {
			value: {
				type: Object,
				default(){
					return {
						all: []
					}
				}
			},
			findId: {
				type: String,
				default: '',
			},
		},
		data () {
			return {
				ver: 1,
				CAT_DIRECTIONS: this.$GVO.cats.CAT_DIRECTIONS,
				cat_timer: null,
			}
		},
		computed: {

		},
		methods: {

		},
		created() {
			this.cat_timer = setInterval(() => {
				//console.log('cat_timer');
				if (typeof this.$GVO.cats.CAT_DIRECTIONS != 'undefined') {
					this.CAT_DIRECTIONS = {'n':[],'s':[]}
					for (let i = 0; i < this.$GVO.cats.CAT_DIRECTIONS.length; i++) {
						if(this.$GVO.cats.CAT_DIRECTIONS[i].group_way == 1){
							this.CAT_DIRECTIONS.n.push(this.$GVO.cats.CAT_DIRECTIONS[i]);
						}else if(this.$GVO.cats.CAT_DIRECTIONS[i].group_way == 2){
							this.CAT_DIRECTIONS.s.push(this.$GVO.cats.CAT_DIRECTIONS[i]);
						}
					}
					clearTimeout(this.cat_timer);
					this.cat_timer = null;
				}
			}, 250);
		}
	}
</script>
<style scoped>
	.ReSelectDirection .el-checkbox-group{
		display: flex;
		align-content: space-between;
	}
	.ReSelectDirection .el-checkbox{width:100%;}
</style>
